export const Sparkle = ({ size = 14, className = "", color = "#A9875F" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 0C12.9 7.2 16.8 11.1 24 12C16.8 12.9 12.9 16.8 12 24C11.1 16.8 7.2 12.9 0 12C7.2 11.1 11.1 7.2 12 0Z"
      fill={color}
    />
  </svg>
);

export const SparkleDivider = ({ light = false }) => (
  <div className="flex items-center justify-center gap-4" aria-hidden="true">
    <span className={`h-px w-16 sm:w-24 ${light ? "bg-gold/70" : "bg-gold"}`} />
    <Sparkle size={12} />
    <span className={`h-px w-16 sm:w-24 ${light ? "bg-gold/70" : "bg-gold"}`} />
  </div>
);
